export const common = {
  // Navbar
  'nav.overview': 'Bayyani',
  'nav.directory': 'Littafin Coci',
  'nav.worship': 'Ayyukan Ibada',
  'nav.live': 'Ranar Asabar Kai Tsaye',
  'nav.ministries': 'Hidimomin',
  'nav.leadership': 'Jagoranci',
  'nav.adminLogin': 'Shiga Admin',
  'nav.language': 'Harshe',
  
  // Language names
  'lang.english': 'Turanci',
  'lang.yoruba': 'Yarbanci',
  'lang.hausa': 'Hausa',
  'lang.igbo': 'Igbo',
  'lang.pidgin': 'Pidgin',
  
  // Hero Section
  'hero.badge': 'Tsarin Ibada na Dijital na Ƙasa',
  'hero.title': 'Ƙarfafa Kowace Cocin Seventh-day Adventist a Najeriya',
  'hero.description': 'Dandamalin dijital guda ɗaya wanda ke haɗa dukkan cococi na SDA a fadin Najeriya. Samun damar ayyukan ibada kai tsaye, nemo cococi kusa da ku, sarrafa abubuwan da suka faru, da ƙarfafa al\'ummarmu ta hanyar fasaha.',
  'hero.exploreChurches': 'Bincika Cococi',
  'hero.worshipTools': 'Kayan Aikin Ibada',
  'hero.liveNow': 'Kai Tsaye Yanzu',
  'hero.scrollExplore': 'Gungura don bincika',
  
  // Stats
  'stats.churches': 'Cococi',
  'stats.members': 'Membobi Masu Aiki',
  'stats.liveServices': 'Ayyukan Kai Tsaye Mako-mako',
  'stats.events': 'Abubuwan Da Suka Faru Wata-wata',
  
  // Features
  'features.watchLive': 'Kalli Kai Tsaye',
  'features.watchLiveDesc': 'Shiga ayyukan ibada kai tsaye daga cococi a fadin Najeriya',
  'features.findChurch': 'Nemo Coci',
  'features.findChurchDesc': 'Gano cococi na SDA a yankinku tare da cikakken bayani',
  'features.events': 'Abubuwan Da Suka Faru',
  'features.eventsDesc': 'Kasance cikin sabuntawa game da tarurruka, shirye-shirye, da ayyuka',
  'features.ministriesTitle': 'Hidimomin',
  'features.ministriesDesc': 'Haɗu da sassa daban-daban na hidima da shirye-shirye',
  
  // CTA
  'cta.title': 'Shirye Don Haɗa Cocin Ku?',
  'cta.description': 'Shiga cibiyar sadarwa ta ƙasa kuma kawo ikilisiyar ku cikin zamanin dijital. Samun damar kayan aiki masu ƙarfi don ibada, sadarwa, da gina al\'umma.',
  'cta.getStarted': 'Fara Yau',
  'cta.learnMore': 'Koyi Ƙari',
  
  // Footer
  'footer.tagline': 'Haɗa cococi na Seventh-day Adventist a fadin Najeriya ta hanyar sabbin hanyoyin dijital.',
  'footer.quickLinks': 'Hanyoyin Sauri',
  'footer.resources': 'Albarkatu',
  'footer.contact': 'Tuntuɓi',
  'footer.home': 'Gida',
  'footer.about': 'Game da Mu',
  'footer.churches': 'Cococi',
  'footer.liveStream': 'Yawo Kai Tsaye',
  'footer.worshipGuide': 'Jagorar Ibada',
  'footer.techSupport': 'Tallafin Fasaha',
  'footer.training': 'Horo',
  'footer.documentation': 'Takaddun',
  'footer.email': 'Imel',
  'footer.phone': 'Waya',
  'footer.address': 'Adireshi',
  'footer.rights': 'Duk haƙƙoƙin da aka keɓe.',
  'footer.privacy': 'Manufar Sirri',
  'footer.terms': 'Sharuɗɗan Sabis',
  
  // Directory Page
  'directory.title': 'Littafin Coci',
  'directory.subtitle': 'Nemo cococi na Seventh-day Adventist a fadin Najeriya',
  'directory.search': 'Nemo cococi...',
  'directory.allRegions': 'Duk Yankuna',
  'directory.allStates': 'Duk Jihohi',
  'directory.viewDetails': 'Duba Cikakkun Bayanai',
  'directory.getDirections': 'Sami Jagora',
  'directory.members': 'membobi',
  
  // Live Page
  'live.title': 'Ayyukan Ibada Kai Tsaye',
  'live.subtitle': 'Shiga ayyukan Asabar kai tsaye daga cococi a fadin Najeriya',
  'live.allRegions': 'Duk Yankuna',
  'live.watchNow': 'Kalli Yanzu',
  'live.viewers': 'masu kallo',
  'live.starting': 'Farawa',
  
  // Events Page
  'events.title': 'Abubuwan Da Ke Zuwa',
  'events.subtitle': 'Gano tarurruka, bita, da shirye-shirye a fadin Najeriya',
  'events.allCategories': 'Duk Rukunoni',
  'events.register': 'Yi Rajista Yanzu',
  'events.learnMore': 'Koyi Ƙari',
  'events.attendees': 'masu halarta',
  
  // Ministries Page
  'ministries.title': 'Sassan Hidima',
  'ministries.subtitle': 'Bincika shirye-shiryen hidima da sassan mu daban-daban',
  'ministries.learnMore': 'Koyi Ƙari',
  'ministries.programs': 'shirye-shirye',
  
  // Tools Page
  'tools.title': 'Kayan Aikin Ibada',
  'tools.subtitle': 'Hanyoyin dijital don gudanar da coci na zamani',
  'tools.getStarted': 'Fara',
  'tools.learnMore': 'Koyi Ƙari',
};

export default {
  // ... existing code ...
  
  // New translations for enhanced landing page
  whatYouCanDo: 'Abin Da Zaka Iya Yi',
  platformDescription: 'Gano dukkan hanyoyin da dandalinmu ke taimaka muku ku kasance a hade da al\'ummar cocin ku da kuma girma cikin bangaskiya',
  learnMore: 'Kara Koyo',
  
  howItWorks: 'Yadda Yake Aiki',
  howItWorksDesc: 'Farawa yana da sauki. Bi wadannan matakai hudu masu sauki don fara tafiyar ku',
  
  discoverChurches: 'Gano Coci-coci',
  discoverChurchesDesc: 'Bincika cikakken jerin coci-cocin Seventh-day Adventist a duk fadin Najeriya. Nemo wurare, lokutan hidima, da bayanan tuntubar',
  
  joinWorship: 'Shiga Sujada Kai Tsaye',
  joinWorshipDesc: 'Kalli hidimomi masu watsa kai tsaye daga coci-coci a duk fadin kasar. Sami gogewar sujada daga ko\'ina, kowane lokaci',
  
  participateEvents: 'Shiga Cikin Abubuwan Da Suka Faru',
  participateEventsDesc: 'Kasance cikin sanarwa game da tarurruka, bita, da shirye-shiryen al\'umma. Yi rajista kuma ku shiga cikin abubuwan da ke zuwa',
  
  connectCommunity: 'Haɗu Da Al\'umma',
  connectCommunityDesc: 'Shiga tare da ayyuka, shiga ƙananan ƙungiyoyi, kuma gina dangantaka mai ma\'ana tare da \'yan\'uwa masu bi',
  
  whyChooseUs: 'Me Yasa Za Ku Zaɓi Dandalinmu',
  whyChooseUsDesc: 'An gina shi musamman don al\'ummar Seventh-day Adventist a Najeriya tare da fasalolin da suka fi dacewa',
  
  accessAnywhere: 'Samun Dama A Ko\'ina',
  accessAnywhereDesc: 'Haɗu da al\'ummar cocin ku daga kowace na\'ura, ko kuna gida ko kuna tafiya',
  
  secureReliable: 'Amintacce & Abin Dogara',
  secureReliableDesc: 'Ana kare bayananku tare da tsaron matakin kasuwanci. Ji daɗin sabis mara katsewa da zaku iya dogara da shi',
  
  mobileOptimized: 'An Inganta Wayar Hannu',
  mobileOptimizedDesc: 'Cikakken ƙirar martani tana tabbatar da gogewar mara nauyi akan wayoyin hannu, allunan, da kwamfutoci',
  
  communityFocused: 'Mayar Da Hankali Ga Al\'umma',
  communityFocusedDesc: 'An gina shi tare da shigar da shugabannin coci da membobi don hidimar bukatun na musamman na al\'ummarmu',
  
  stayUpdated: 'Kasance A Sabunta',
  stayUpdatedDesc: 'Karɓi sanarwa game da muhimman abubuwan da suka faru, sabbin wa\'azai, da sanarwar al\'umma',
  
  comprehensiveTools: 'Kayan Aiki Masu Cikakke',
  comprehensiveToolsDesc: 'Samun dama ga cikakken jerin kayan aikin dijital da aka tsara don inganta gudanarwar coci da haɗin gwiwar membobi'
};
